import { render, staticRenderFns } from "./FormioForm.vue?vue&type=template&id=b8008a68&scoped=true"
import script from "./FormioForm.vue?vue&type=script&lang=js"
export * from "./FormioForm.vue?vue&type=script&lang=js"
import style0 from "./FormioForm.vue?vue&type=style&index=0&id=b8008a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8008a68",
  null
  
)

export default component.exports